//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ClientBase {
  protected transformOptions(options: RequestInit): Promise<RequestInit> {
    // 1. Handle Authorization Token
    const token = localStorage.getItem("meatbid_token")
    if (token) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      }
    }

    // 2. Automatic FormData conversion for multipart/form-data
    const headers = options.headers as Record<string, string>
    const contentType = headers ? headers["Content-Type"] || headers["content-type"] : undefined

    if (contentType === "multipart/form-data") {
      // Remove Content-Type to let browser set boundary
      if (headers["Content-Type"]) delete headers["Content-Type"]
      if (headers["content-type"]) delete headers["content-type"]
    }

    return Promise.resolve(options)
  }
}

export interface IClient {

    /**
     * @return OK
     */
    login(body: LoginRequest): Promise<AuthResponse>;

    /**
     * @return OK
     */
    register(body: RegisterRequest): Promise<RegisterResponse>;

    /**
     * @return OK
     */
    externalLogin(body: ExternalAuthRequest): Promise<AuthResponse>;

    /**
     * @return OK
     */
    forgotPassword(body: ForgotPasswordRequest): Promise<void>;

    /**
     * @return OK
     */
    resetPassword(body: ResetPasswordRequest): Promise<void>;

    /**
     * @return OK
     */
    verifyEmail(userId: string, token: string): Promise<string>;

    /**
     * @param searchTerm (optional) 
     * @param categoryId (optional) 
     * @param providerIds (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param minWeight (optional) 
     * @param maxWeight (optional) 
     * @param sortBy (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param consumptionType (optional) 
     * @return OK
     */
    getAllProducts(searchTerm?: string | undefined, categoryId?: number | undefined, providerIds?: number[] | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, minWeight?: number | undefined, maxWeight?: number | undefined, sortBy?: string | undefined, page?: number | undefined, pageSize?: number | undefined, consumptionType?: ConsumptionType | undefined): Promise<ProductPageResponseDto>;

    /**
     * @param files (optional) 
     * @return Created
     */
    createProduct(files?: string[] | undefined): Promise<Product>;

    /**
     * @return OK
     */
    getProductById(id: number): Promise<ProductResponseDto>;

    /**
     * @param files (optional) 
     * @return OK
     */
    updateProduct(id: number, files?: string[] | undefined): Promise<Product>;

    /**
     * @return No Content
     */
    deleteProduct(id: number): Promise<void>;

    /**
     * @return Created
     */
    createOrder(body: OrderCreateDto): Promise<Order>;

    /**
     * @return OK
     */
    getMyOrders(): Promise<Order[]>;

    /**
     * @return OK
     */
    createSubOrderCheckoutSession(subOrderId: number): Promise<CheckoutResponse>;

    /**
     * @return OK
     */
    getUserAddresses(): Promise<UserAddressDto[]>;

    /**
     * @return Created
     */
    createAddress(body: UserAddressCreateDto): Promise<UserAddressDto>;

    /**
     * @return OK
     */
    getAddressById(id: number): Promise<UserAddressDto>;

    /**
     * @return OK
     */
    updateAddress(id: number, body: UserAddressUpdateDto): Promise<UserAddressDto>;

    /**
     * @return No Content
     */
    deleteAddress(id: number): Promise<void>;

    /**
     * @return No Content
     */
    setDefaultAddress(id: number): Promise<void>;

    /**
     * @return OK
     */
    getProductBatches(productId: number): Promise<InventoryBatch[]>;

    /**
     * @return Created
     */
    createInventoryBatch(productId: number, body: InventoryBatch): Promise<InventoryBatch>;

    /**
     * @return OK
     */
    getVendorOrders(): Promise<SubOrder[]>;

    /**
     * @return OK
     */
    getVendorSubOrderHistory(id: number): Promise<SubOrderStatusHistoryDto[]>;

    /**
     * @param days (optional) 
     * @return OK
     */
    getVendorAnalytics(days?: number | undefined): Promise<VendorAnalyticsDto>;

    /**
     * @return OK
     */
    updateVendorSubOrderStatus(id: number, newStatus: OrderStatus): Promise<void>;

    /**
     * @return OK
     */
    quoteSubOrderShipping(id: number, body: ShippingQuoteDto): Promise<void>;

    /**
     * @return OK
     */
    getVendorProducts(): Promise<ProductResponseDto[]>;

    /**
     * @return OK
     */
    getCategoryTree(): Promise<CategoryDto[]>;

    /**
     * @return Created
     */
    createCategory(body: CreateCategoryRequest): Promise<CategoryDto>;

    /**
     * @return OK
     */
    updateCategory(id: number, body: UpdateCategoryRequest): Promise<CategoryDto>;

    /**
     * @return No Content
     */
    deleteCategory(id: number): Promise<void>;

    /**
     * @return OK
     */
    getAllProviders(): Promise<ProviderDto[]>;

    /**
     * @return OK
     */
    getProviderById(id: number): Promise<ProviderDto>;

    /**
     * @return Created
     */
    createProvider(body: ProviderCreateDto): Promise<ProviderDto>;

    /**
     * @return OK
     */
    updateProvider(id: number, body: ProviderUpdateDto): Promise<ProviderDto>;

    /**
     * @return No Content
     */
    deleteProvider(id: number): Promise<void>;

    /**
     * @return OK
     */
    sendContactInquiry(body: ContactRequest): Promise<void>;

    /**
     * @return OK
     */
    sendProductInquiry(body: ProductInquiryRequest): Promise<void>;

    /**
     * @return OK
     */
    conektaWebhook(): Promise<void>;

    /**
     * @return OK
     */
    getAllWarehouses(): Promise<WarehouseDto[]>;

    /**
     * @return OK
     */
    getWarehouseInventoryAvailability(productIds: number[]): Promise<WarehouseInventoryAvailabilityDto[]>;

    /**
     * @return OK
     */
    getWarehouseById(id: number): Promise<WarehouseDto>;

    /**
     * @return Created
     */
    createWarehouse(body: WarehouseCreateDto): Promise<WarehouseDto>;

    /**
     * @return OK
     */
    updateWarehouse(id: number, body: WarehouseUpdateDto): Promise<WarehouseDto>;

    /**
     * @return No Content
     */
    deleteWarehouse(id: number): Promise<void>;

    /**
     * @return OK
     */
    getPostalCodeInfo(cp: string): Promise<PostalCodeLookupDto>;
}

export class Client extends ClientBase implements IClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5067/";
    }

    /**
     * @return OK
     */
    login(body: LoginRequest): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginErrorResponse;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    register(body: RegisterRequest): Promise<RegisterResponse> {
        let url_ = this.baseUrl + "/api/auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<RegisterResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdentityError[];
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterResponse>(null as any);
    }

    /**
     * @return OK
     */
    externalLogin(body: ExternalAuthRequest): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/api/auth/external-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExternalLogin(_response);
        });
    }

    protected processExternalLogin(response: Response): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    forgotPassword(body: ForgotPasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    resetPassword(body: ResetPasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdentityError[];
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    verifyEmail(userId: string, token: string): Promise<string> {
        let url_ = this.baseUrl + "/api/auth/verify-email?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param categoryId (optional) 
     * @param providerIds (optional) 
     * @param minPrice (optional) 
     * @param maxPrice (optional) 
     * @param minWeight (optional) 
     * @param maxWeight (optional) 
     * @param sortBy (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param consumptionType (optional) 
     * @return OK
     */
    getAllProducts(searchTerm?: string | undefined, categoryId?: number | undefined, providerIds?: number[] | undefined, minPrice?: number | undefined, maxPrice?: number | undefined, minWeight?: number | undefined, maxWeight?: number | undefined, sortBy?: string | undefined, page?: number | undefined, pageSize?: number | undefined, consumptionType?: ConsumptionType | undefined): Promise<ProductPageResponseDto> {
        let url_ = this.baseUrl + "/api/products?";
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (providerIds === null)
            throw new globalThis.Error("The parameter 'providerIds' cannot be null.");
        else if (providerIds !== undefined)
            providerIds && providerIds.forEach(item => { url_ += "providerIds=" + encodeURIComponent("" + item) + "&"; });
        if (minPrice === null)
            throw new globalThis.Error("The parameter 'minPrice' cannot be null.");
        else if (minPrice !== undefined)
            url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
        if (maxPrice === null)
            throw new globalThis.Error("The parameter 'maxPrice' cannot be null.");
        else if (maxPrice !== undefined)
            url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
        if (minWeight === null)
            throw new globalThis.Error("The parameter 'minWeight' cannot be null.");
        else if (minWeight !== undefined)
            url_ += "MinWeight=" + encodeURIComponent("" + minWeight) + "&";
        if (maxWeight === null)
            throw new globalThis.Error("The parameter 'maxWeight' cannot be null.");
        else if (maxWeight !== undefined)
            url_ += "MaxWeight=" + encodeURIComponent("" + maxWeight) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (consumptionType === null)
            throw new globalThis.Error("The parameter 'consumptionType' cannot be null.");
        else if (consumptionType !== undefined)
            url_ += "ConsumptionType=" + encodeURIComponent("" + consumptionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProducts(_response);
        });
    }

    protected processGetAllProducts(response: Response): Promise<ProductPageResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPageResponseDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductPageResponseDto>(null as any);
    }

    /**
     * @param files (optional) 
     * @return Created
     */
    createProduct(files?: string[] | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProduct(_response);
        });
    }

    protected processCreateProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * @return OK
     */
    getProductById(id: number): Promise<ProductResponseDto> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductById(_response);
        });
    }

    protected processGetProductById(response: Response): Promise<ProductResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductResponseDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResponseDto>(null as any);
    }

    /**
     * @param files (optional) 
     * @return OK
     */
    updateProduct(id: number, files?: string[] | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new globalThis.Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * @return No Content
     */
    deleteProduct(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProduct(_response);
        });
    }

    protected processDeleteProduct(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Created
     */
    createOrder(body: OrderCreateDto): Promise<Order> {
        let url_ = this.baseUrl + "/api/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOrder(_response);
        });
    }

    protected processCreateOrder(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Order;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * @return OK
     */
    getMyOrders(): Promise<Order[]> {
        let url_ = this.baseUrl + "/api/orders/my-orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyOrders(_response);
        });
    }

    protected processGetMyOrders(response: Response): Promise<Order[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Order[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order[]>(null as any);
    }

    /**
     * @return OK
     */
    createSubOrderCheckoutSession(subOrderId: number): Promise<CheckoutResponse> {
        let url_ = this.baseUrl + "/api/orders/suborders/{subOrderId}/checkout-session";
        if (subOrderId === undefined || subOrderId === null)
            throw new globalThis.Error("The parameter 'subOrderId' must be defined.");
        url_ = url_.replace("{subOrderId}", encodeURIComponent("" + subOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubOrderCheckoutSession(_response);
        });
    }

    protected processCreateSubOrderCheckoutSession(response: Response): Promise<CheckoutResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckoutResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckoutResponse>(null as any);
    }

    /**
     * @return OK
     */
    getUserAddresses(): Promise<UserAddressDto[]> {
        let url_ = this.baseUrl + "/api/addresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAddresses(_response);
        });
    }

    protected processGetUserAddresses(response: Response): Promise<UserAddressDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAddressDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAddressDto[]>(null as any);
    }

    /**
     * @return Created
     */
    createAddress(body: UserAddressCreateDto): Promise<UserAddressDto> {
        let url_ = this.baseUrl + "/api/addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAddress(_response);
        });
    }

    protected processCreateAddress(response: Response): Promise<UserAddressDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAddressDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAddressDto>(null as any);
    }

    /**
     * @return OK
     */
    getAddressById(id: number): Promise<UserAddressDto> {
        let url_ = this.baseUrl + "/api/addresses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAddressById(_response);
        });
    }

    protected processGetAddressById(response: Response): Promise<UserAddressDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAddressDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAddressDto>(null as any);
    }

    /**
     * @return OK
     */
    updateAddress(id: number, body: UserAddressUpdateDto): Promise<UserAddressDto> {
        let url_ = this.baseUrl + "/api/addresses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: Response): Promise<UserAddressDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAddressDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAddressDto>(null as any);
    }

    /**
     * @return No Content
     */
    deleteAddress(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/addresses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAddress(_response);
        });
    }

    protected processDeleteAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    setDefaultAddress(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/addresses/{id}/default";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDefaultAddress(_response);
        });
    }

    protected processSetDefaultAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getProductBatches(productId: number): Promise<InventoryBatch[]> {
        let url_ = this.baseUrl + "/api/vendor/products/{productId}/batches";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProductBatches(_response);
        });
    }

    protected processGetProductBatches(response: Response): Promise<InventoryBatch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventoryBatch[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBatch[]>(null as any);
    }

    /**
     * @return Created
     */
    createInventoryBatch(productId: number, body: InventoryBatch): Promise<InventoryBatch> {
        let url_ = this.baseUrl + "/api/vendor/products/{productId}/batches";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInventoryBatch(_response);
        });
    }

    protected processCreateInventoryBatch(response: Response): Promise<InventoryBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InventoryBatch;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InventoryBatch>(null as any);
    }

    /**
     * @return OK
     */
    getVendorOrders(): Promise<SubOrder[]> {
        let url_ = this.baseUrl + "/api/vendor/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorOrders(_response);
        });
    }

    protected processGetVendorOrders(response: Response): Promise<SubOrder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubOrder[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubOrder[]>(null as any);
    }

    /**
     * @return OK
     */
    getVendorSubOrderHistory(id: number): Promise<SubOrderStatusHistoryDto[]> {
        let url_ = this.baseUrl + "/api/vendor/orders/{id}/history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorSubOrderHistory(_response);
        });
    }

    protected processGetVendorSubOrderHistory(response: Response): Promise<SubOrderStatusHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubOrderStatusHistoryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubOrderStatusHistoryDto[]>(null as any);
    }

    /**
     * @param days (optional) 
     * @return OK
     */
    getVendorAnalytics(days?: number | undefined): Promise<VendorAnalyticsDto> {
        let url_ = this.baseUrl + "/api/vendor/analytics?";
        if (days === null)
            throw new globalThis.Error("The parameter 'days' cannot be null.");
        else if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorAnalytics(_response);
        });
    }

    protected processGetVendorAnalytics(response: Response): Promise<VendorAnalyticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorAnalyticsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorAnalyticsDto>(null as any);
    }

    /**
     * @return OK
     */
    updateVendorSubOrderStatus(id: number, newStatus: OrderStatus): Promise<void> {
        let url_ = this.baseUrl + "/api/vendor/orders/{id}/status?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newStatus === undefined || newStatus === null)
            throw new globalThis.Error("The parameter 'newStatus' must be defined and cannot be null.");
        else
            url_ += "newStatus=" + encodeURIComponent("" + newStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateVendorSubOrderStatus(_response);
        });
    }

    protected processUpdateVendorSubOrderStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    quoteSubOrderShipping(id: number, body: ShippingQuoteDto): Promise<void> {
        let url_ = this.baseUrl + "/api/vendor/orders/{id}/shipping-quote";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuoteSubOrderShipping(_response);
        });
    }

    protected processQuoteSubOrderShipping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getVendorProducts(): Promise<ProductResponseDto[]> {
        let url_ = this.baseUrl + "/api/vendor/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorProducts(_response);
        });
    }

    protected processGetVendorProducts(response: Response): Promise<ProductResponseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductResponseDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductResponseDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getCategoryTree(): Promise<CategoryDto[]> {
        let url_ = this.baseUrl + "/api/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategoryTree(_response);
        });
    }

    protected processGetCategoryTree(response: Response): Promise<CategoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDto[]>(null as any);
    }

    /**
     * @return Created
     */
    createCategory(body: CreateCategoryRequest): Promise<CategoryDto> {
        let url_ = this.baseUrl + "/api/categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCategory(_response);
        });
    }

    protected processCreateCategory(response: Response): Promise<CategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDto>(null as any);
    }

    /**
     * @return OK
     */
    updateCategory(id: number, body: UpdateCategoryRequest): Promise<CategoryDto> {
        let url_ = this.baseUrl + "/api/categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCategory(_response);
        });
    }

    protected processUpdateCategory(response: Response): Promise<CategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDto>(null as any);
    }

    /**
     * @return No Content
     */
    deleteCategory(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCategory(_response);
        });
    }

    protected processDeleteCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAllProviders(): Promise<ProviderDto[]> {
        let url_ = this.baseUrl + "/api/providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProviders(_response);
        });
    }

    protected processGetAllProviders(response: Response): Promise<ProviderDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getProviderById(id: number): Promise<ProviderDto> {
        let url_ = this.baseUrl + "/api/providers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProviderById(_response);
        });
    }

    protected processGetProviderById(response: Response): Promise<ProviderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDto>(null as any);
    }

    /**
     * @return Created
     */
    createProvider(body: ProviderCreateDto): Promise<ProviderDto> {
        let url_ = this.baseUrl + "/api/admin/providers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProvider(_response);
        });
    }

    protected processCreateProvider(response: Response): Promise<ProviderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderDto;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDto>(null as any);
    }

    /**
     * @return OK
     */
    updateProvider(id: number, body: ProviderUpdateDto): Promise<ProviderDto> {
        let url_ = this.baseUrl + "/api/admin/providers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProvider(_response);
        });
    }

    protected processUpdateProvider(response: Response): Promise<ProviderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDto>(null as any);
    }

    /**
     * @return No Content
     */
    deleteProvider(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/providers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteProvider(_response);
        });
    }

    protected processDeleteProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    sendContactInquiry(body: ContactRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendContactInquiry(_response);
        });
    }

    protected processSendContactInquiry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    sendProductInquiry(body: ProductInquiryRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/contact/product-inquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendProductInquiry(_response);
        });
    }

    protected processSendProductInquiry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    conektaWebhook(): Promise<void> {
        let url_ = this.baseUrl + "/api/webhooks/conekta";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConektaWebhook(_response);
        });
    }

    protected processConektaWebhook(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getAllWarehouses(): Promise<WarehouseDto[]> {
        let url_ = this.baseUrl + "/api/warehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllWarehouses(_response);
        });
    }

    protected processGetAllWarehouses(response: Response): Promise<WarehouseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getWarehouseInventoryAvailability(productIds: number[]): Promise<WarehouseInventoryAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/warehouses/inventory-availability?";
        if (productIds === undefined || productIds === null)
            throw new globalThis.Error("The parameter 'productIds' must be defined and cannot be null.");
        else
            productIds && productIds.forEach(item => { url_ += "productIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWarehouseInventoryAvailability(_response);
        });
    }

    protected processGetWarehouseInventoryAvailability(response: Response): Promise<WarehouseInventoryAvailabilityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseInventoryAvailabilityDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseInventoryAvailabilityDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getWarehouseById(id: number): Promise<WarehouseDto> {
        let url_ = this.baseUrl + "/api/warehouses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWarehouseById(_response);
        });
    }

    protected processGetWarehouseById(response: Response): Promise<WarehouseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto>(null as any);
    }

    /**
     * @return Created
     */
    createWarehouse(body: WarehouseCreateDto): Promise<WarehouseDto> {
        let url_ = this.baseUrl + "/api/admin/warehouses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateWarehouse(_response);
        });
    }

    protected processCreateWarehouse(response: Response): Promise<WarehouseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto>(null as any);
    }

    /**
     * @return OK
     */
    updateWarehouse(id: number, body: WarehouseUpdateDto): Promise<WarehouseDto> {
        let url_ = this.baseUrl + "/api/admin/warehouses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWarehouse(_response);
        });
    }

    protected processUpdateWarehouse(response: Response): Promise<WarehouseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarehouseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto>(null as any);
    }

    /**
     * @return No Content
     */
    deleteWarehouse(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/warehouses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteWarehouse(_response);
        });
    }

    protected processDeleteWarehouse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getPostalCodeInfo(cp: string): Promise<PostalCodeLookupDto> {
        let url_ = this.baseUrl + "/api/postal-codes/{cp}";
        if (cp === undefined || cp === null)
            throw new globalThis.Error("The parameter 'cp' must be defined.");
        url_ = url_.replace("{cp}", encodeURIComponent("" + cp));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPostalCodeInfo(_response);
        });
    }

    protected processGetPostalCodeInfo(response: Response): Promise<PostalCodeLookupDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostalCodeLookupDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostalCodeLookupDto>(null as any);
    }
}

export interface Address {
    street: string;
    externalNumber: string;
    internalNumber?: string | undefined;
    neighborhood: string;
    city: string;
    state: string;
    zipCode: string;
    country?: string;

    [key: string]: any;
}

export interface AddressDto {
    street: string;
    externalNumber: string;
    internalNumber: string | undefined;
    neighborhood: string;
    city: string;
    state: string;
    zipCode: string;
    country?: string;

    [key: string]: any;
}

export interface AuthResponse {
    email: string;
    displayName: string;
    token: string;

    [key: string]: any;
}

export interface Category {
    id?: number;
    nameEs: string;
    nameEn: string;
    parentId?: number | undefined;
    subcategories?: Category[];

    [key: string]: any;
}

export interface CategoryDto {
    id: number;
    nameEs: string;
    nameEn: string;
    parentId: number | undefined;
    subcategories: CategoryDto[];

    [key: string]: any;
}

export interface CheckoutResponse {
    id?: string;
    url?: string;
    type?: string;

    [key: string]: any;
}

export enum ConsumptionType {
    Human = "Human",
    Industrial = "Industrial",
}

export interface ContactRequest {
    name: string;
    email: string;
    subject: string;
    message: string;
    honeypot?: string | undefined;
    turnstileToken?: string | undefined;

    [key: string]: any;
}

export interface CreateCategoryRequest {
    nameEs: string;
    nameEn: string;
    parentId: number | undefined;

    [key: string]: any;
}

export interface ExternalAuthRequest {
    provider: string;
    idToken: string;

    [key: string]: any;
}

export interface ForgotPasswordRequest {
    email: string;
    language?: string;

    [key: string]: any;
}

export enum FulfillmentType {
    Delivery = "Delivery",
    Pickup = "Pickup",
}

export interface HttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export interface IdentityError {
    code?: string;
    description?: string;

    [key: string]: any;
}

export interface InventoryBatch {
    id?: number;
    productId?: number;
    product?: Product | undefined;
    warehouseId?: number | undefined;
    warehouse?: Warehouse | undefined;
    batchNumber: string;
    quantity?: number;
    initialQuantity?: number;
    expirationDate?: Date | undefined;
    arrivalDate?: Date;
    unitCost?: number;

    [key: string]: any;
}

export interface InventoryHealthDto {
    totalProducts: number;
    lowStockCount: number;
    outOfStockCount: number;

    [key: string]: any;
}

export interface LoginErrorResponse {
    code: string;
    message: string;

    [key: string]: any;
}

export interface LoginRequest {
    email: string;
    password: string;

    [key: string]: any;
}

export interface Order {
    id?: number;
    orderDate?: Date;
    buyerId: string;
    buyer?: User | undefined;
    items?: OrderItem[];
    subOrders?: SubOrder[];
    subTotal?: number;
    taxRate?: number;
    taxAmount?: number;
    totalAmount?: number;
    status?: OrderStatus;
    receiverName?: string | undefined;
    phone?: string | undefined;
    street?: string | undefined;
    externalNumber?: string | undefined;
    internalNumber?: string | undefined;
    neighborhood?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string;

    [key: string]: any;
}

export interface OrderCreateDto {
    receiverName: string;
    phone: string;
    street: string;
    externalNumber: string;
    internalNumber: string | undefined;
    neighborhood: string;
    city: string;
    state: string;
    zipCode: string;
    items: OrderItemCreateDto[];

    [key: string]: any;
}

export interface OrderItem {
    id?: number;
    productId?: number;
    product?: Product | undefined;
    productName: string;
    sku?: string | undefined;
    price?: number;
    unitCost?: number;
    quantity?: number;
    isTaxable?: boolean;
    providerId?: number | undefined;
    providerName?: string | undefined;
    weight?: number;
    weightUnit?: string;
    pricePerWeightUnit?: number;
    orderId?: number;
    order?: Order | undefined;
    subOrderId?: number | undefined;
    subOrder?: SubOrder | undefined;

    [key: string]: any;
}

export interface OrderItemCreateDto {
    productId: number;
    quantity: number;
    pickupWarehouseId?: number | undefined;

    [key: string]: any;
}

export interface OrderPayment {
    id?: number;
    subOrderId?: number;
    subOrder?: SubOrder | undefined;
    status?: PaymentStatus;
    conektaOrderId?: string | undefined;
    amount?: number;
    createdAt?: Date;
    statusUpdatedAt?: Date | undefined;
    lastWebhookEventId?: number | undefined;
    lastWebhookEvent?: WebhookEvent | undefined;

    [key: string]: any;
}

export enum OrderStatus {
    Pending = "Pending",
    StockVerified = "StockVerified",
    PaymentReceived = "PaymentReceived",
    OrderDeclined = "OrderDeclined",
    OrderShipped = "OrderShipped",
    OrderComplete = "OrderComplete",
    ShippingQuoted = "ShippingQuoted",
    ReadyForPickup = "ReadyForPickup",
}

export enum PaymentStatus {
    Pending = "Pending",
    Processing = "Processing",
    Paid = "Paid",
    Failed = "Failed",
    Refunded = "Refunded",
    Chargeback = "Chargeback",
}

export interface PostalCodeLookupDto {
    zipCode: string;
    state: string;
    municipality: string;
    city: string;
    colonias: string[];

    [key: string]: any;
}

export interface Product {
    id?: number;
    name: string;
    sku?: string | undefined;
    description?: string | undefined;
    price?: number;
    unitCost?: number;
    weight?: number;
    weightUnit?: string;
    stockQuantity?: number;
    lowStockThreshold?: number;
    leadTimeDays?: number;
    safetyStockLevel?: number;
    isTaxable?: boolean;
    vendorId: string;
    vendor?: User | undefined;
    categoryId?: number | undefined;
    category?: Category | undefined;
    categoryHierarchyIds?: number[];
    providerId?: number | undefined;
    provider?: Provider | undefined;
    images?: ProductImage[];
    technicalSpecification?: ProductTechnicalSpecification | undefined;
    batches?: InventoryBatch[];
    consumptionType?: ConsumptionType;

    [key: string]: any;
}

export interface ProductCreateDto {
    name?: string;
    sku?: string | undefined;
    description?: string | undefined;
    price?: number;
    unitCost?: number;
    weight?: number;
    weightUnit?: string;
    initialStock?: number;
    lowStockThreshold?: number;
    leadTimeDays?: number;
    safetyStockLevel?: number;
    isTaxable?: boolean;
    categoryId?: number | undefined;
    providerId?: number | undefined;
    warehouseId?: number | undefined;
    consumptionType?: ConsumptionType;
    primaryImageIndex?: number;
    images?: string[] | undefined;
    technicalSpecification?: string | undefined;

    [key: string]: any;
}

export interface ProductImage {
    id?: number;
    fileName: string;
    fileUrl: string;
    isPrimary?: boolean;
    productId: number;
    product?: Product | undefined;

    [key: string]: any;
}

export interface ProductImageDto {
    id: number;
    fileUrl: string;
    isPrimary: boolean;

    [key: string]: any;
}

export interface ProductInquiryRequest {
    productId: number;
    phone: string;
    message: string;

    [key: string]: any;
}

export interface ProductPageResponseDto {
    items: ProductResponseDto[];
    page: number;
    pageSize: number;
    totalItemCount: number;
    totalPageCount: number;

    [key: string]: any;
}

export interface ProductResponseDto {
    id: number;
    name: string;
    sku: string | undefined;
    description: string | undefined;
    price: number;
    unitCost: number;
    weight: number;
    weightUnit: string;
    stockQuantity: number;
    lowStockThreshold: number;
    leadTimeDays: number;
    safetyStockLevel: number;
    avgDailySales: number;
    reorderPoint: number;
    isTaxable: boolean;
    vendorId: string;
    categoryId: number | undefined;
    categoryName: string | undefined;
    providerId: number | undefined;
    providerName: string | undefined;
    categoryIds: number[];
    primaryImageUrl: string | undefined;
    imageUrls: string[];
    images: ProductImageDto[];
    technicalSpecificationUrl: string | undefined;
    consumptionType: ConsumptionType;
    pricePerWeightUnit?: number;

    [key: string]: any;
}

export interface ProductTechnicalSpecification {
    id?: number;
    fileName: string;
    fileUrl: string;
    productId: number;
    product?: Product | undefined;

    [key: string]: any;
}

export interface ProductUpdateDto {
    name?: string;
    sku?: string | undefined;
    description?: string | undefined;
    price?: number;
    unitCost?: number;
    stockQuantity?: number;
    categoryId?: number | undefined;
    providerId?: number | undefined;
    weight?: number;
    weightUnit?: string;
    lowStockThreshold?: number;
    leadTimeDays?: number;
    safetyStockLevel?: number;
    isTaxable?: boolean;
    consumptionType?: ConsumptionType;
    primaryImageIndex?: number;
    deletedImageIds?: number[] | undefined;
    images?: string[] | undefined;
    technicalSpecification?: string | undefined;

    [key: string]: any;
}

export interface Provider {
    id?: number;
    name: string;
    description?: string | undefined;
    logoUrl?: string | undefined;
    createdDate?: Date;

    [key: string]: any;
}

export interface ProviderCreateDto {
    name: string;
    description: string | undefined;
    logoUrl: string | undefined;

    [key: string]: any;
}

export interface ProviderDto {
    id: number;
    name: string;
    description: string | undefined;
    logoUrl: string | undefined;
    createdDate: Date;

    [key: string]: any;
}

export interface ProviderUpdateDto {
    name: string;
    description: string | undefined;
    logoUrl: string | undefined;

    [key: string]: any;
}

export interface RegisterRequest {
    email: string;
    password: string;
    displayName: string;
    userType: UserType;
    language?: string;

    [key: string]: any;
}

export interface RegisterResponse {
    email: string;
    requiresEmailVerification: boolean;

    [key: string]: any;
}

export interface ResetPasswordRequest {
    userId: string;
    token: string;
    newPassword: string;

    [key: string]: any;
}

export interface SalesTrendDto {
    date: Date;
    amount: number;

    [key: string]: any;
}

export interface ShippingQuoteDto {
    shippingCost: number;

    [key: string]: any;
}

export interface SubOrder {
    id?: number;
    masterOrderId?: number;
    masterOrder?: Order | undefined;
    vendorId: string;
    vendor?: User | undefined;
    fulfillmentType?: FulfillmentType;
    pickupWarehouseId?: number | undefined;
    pickupWarehouse?: Warehouse | undefined;
    status?: OrderStatus;
    items?: OrderItem[];
    payments?: OrderPayment[];
    subTotal?: number;
    taxRate?: number;
    taxAmount?: number;
    totalAmount?: number;
    shippingCost?: number | undefined;
    isInventoryDeducted?: boolean;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    latestPaymentStatus?: PaymentStatus;

    [key: string]: any;
}

export interface SubOrderStatusHistoryDto {
    id: number;
    subOrderId: number;
    fromStatus: OrderStatus;
    requestedStatus: OrderStatus;
    toStatus: OrderStatus;
    changedAtUtc: Date;
    actorType: string;
    actorUserId: string | undefined;
    actorDisplayName: string | undefined;
    source: string;
    correlationId: string | undefined;
    reason: string | undefined;
    shippingCost: number | undefined;
    paymentId: number | undefined;

    [key: string]: any;
}

export interface TopProductDto {
    productName: string;
    quantitySold: number;
    revenue: number;

    [key: string]: any;
}

export interface UpdateCategoryRequest {
    nameEs: string;
    nameEn: string;
    parentId: number | undefined;

    [key: string]: any;
}

export interface User {
    displayName?: string | undefined;
    conektaCustomerId?: string | undefined;
    userType?: UserType;
    addresses?: UserAddress[];
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    [key: string]: any;
}

export interface UserAddress {
    id?: number;
    userId: string;
    user?: User | undefined;
    receiverName: string;
    phone: string;
    address: Address;
    isDefault?: boolean;

    [key: string]: any;
}

export interface UserAddressCreateDto {
    receiverName: string;
    phone: string;
    address: AddressDto;
    isDefault?: boolean;

    [key: string]: any;
}

export interface UserAddressDto {
    id: number;
    receiverName: string;
    phone: string;
    address: AddressDto;
    isDefault: boolean;

    [key: string]: any;
}

export interface UserAddressUpdateDto {
    receiverName?: string | undefined;
    phone?: string | undefined;
    address?: AddressDto | undefined;
    isDefault?: boolean | undefined;

    [key: string]: any;
}

export enum UserType {
    Buyer = "Buyer",
    Vendor = "Vendor",
    Admin = "Admin",
}

export interface VendorAnalyticsDto {
    salesTrend: SalesTrendDto[];
    topProducts: TopProductDto[];
    inventoryHealth: InventoryHealthDto;
    totalRevenue: number;
    totalOrders: number;
    inventoryTurnoverRatio: number;
    inventoryToSalesRatio: number;
    salesGrowthPercent: number;
    newOrdersToday: number;

    [key: string]: any;
}

export interface Warehouse {
    id?: number;
    name: string;
    address: Address;
    batches?: InventoryBatch[];

    [key: string]: any;
}

export interface WarehouseCreateDto {
    name: string;
    address: AddressDto;

    [key: string]: any;
}

export interface WarehouseDto {
    id: number;
    name: string;
    address: AddressDto;

    [key: string]: any;
}

export interface WarehouseInventoryAvailabilityDto {
    productId: number;
    warehouseId: number;
    availableQuantity: number;
    hasLiveInventory?: boolean;

    [key: string]: any;
}

export interface WarehouseUpdateDto {
    name?: string | undefined;
    address?: AddressDto | undefined;

    [key: string]: any;
}

export interface WebhookEvent {
    id?: number;
    conektaEventId?: string | undefined;
    eventType: string;
    conektaOrderId?: string | undefined;
    rawPayload: string;
    status?: WebhookEventStatus;
    processingError?: string | undefined;
    receivedAt?: Date;
    processedAt?: Date | undefined;

    [key: string]: any;
}

export enum WebhookEventStatus {
    Received = "Received",
    Processed = "Processed",
    Skipped = "Skipped",
    Failed = "Failed",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/**
 * Helper to be used in components to call the API with Files.
 * Since NSwag generation for multipart is often broken (stringifies files),
 * we use this utility to ensure a clean FormData request.
 */
export async function multipartFetch(
  url: string,
  dto: Record<string, any>,
  token: string | null
): Promise<Response> {
  const formData = new FormData()

  for (const key in dto) {
    if (Object.prototype.hasOwnProperty.call(dto, key)) {
      const value = dto[key]
      if (value instanceof File) {
        formData.append(key, value)
      } else if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item instanceof File) {
            formData.append(key, item)
          } else {
            formData.append(key, item.toString())
          }
        })
      } else if (value !== null && value !== undefined) {
        formData.append(key, value.toString())
      }
    }
  }

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
    },
    body: formData,
  })
}